exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fancy-btn[data-v-0332a214]{border-radius:.25rem;border:2px solid transparent;cursor:pointer;display:inline-block;font-weight:500;font-size:.75rem;line-height:1rem;padding:5px 5px 1px}.fancy-btn[data-v-0332a214]:focus{outline:2px solid transparent;outline-offset:2px}.fancy-btn[data-v-0332a214]{text-align:center;text-transform:uppercase}.fancy-btn.active[data-v-0332a214]{border-color:#72a8ff}", ""]);

// exports
